import Layout from '@layout/Index'

export const fairUpload = [
  {
    path: '/fair-upload',
    component: Layout,
    children: [
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "FairUploadTable" */'./pages/FairUploadTable.vue'),
        name: '活动上传列表',
        meta: {
          title: '活动上传列表',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/fair-upload/fairUpload.route.js